import settings from '@tenant/settings'

export const KEY_REGEX = settings?.pinCreator?.keyRegex || /^.*"KEY":\s*(\{.*"}),.*$/
export const MAGIC_REGEX = settings?.pinCreator?.magicRegex || /^.*"Magic":\s*([0-9]+),.*$/

/**
 * Converts a base64 string to a {@link Uint8Array}.
 *
 * @param {string} base64 the input string
 * @returns {Uint8Array<ArrayBuffer>}
 */
export const base64ToUint8Array = (base64) => {
  const binary = atob(base64)
  const len = binary.length
  const bytes = new Uint8Array(len)

  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i)

  return bytes
}

/**
 * Returns an outdated key error
 *
 * @returns {PinError}
 */
export const OutdatedKeyError = () => ({
  type: 'outdated',
  messageKey: 'optionmanagement.error.device-outdated',
  message: 'The device software is out of date.',
})

/**
 * Returns a decryption failed error
 *
 * @returns {PinError}
 */
export const DecryptionFailedError = () => ({
  type: 'malformed',
  messageKey: 'optionmanagement.error.malformed-qr',
  message: 'An error occurred: The scanned QR-Code is incorrect.',
})

/**
 * Parses the contents of the decrypted PIN
 *
 * @param {string} decryptedPin the decrypted PIN
 * @returns {PinContent}
 */
export const parsePinContent = (decryptedPin) => {
  /** @type PIN */
  const content = JSON.parse(decryptedPin)
  const key = content.KEY

  /** @type {[string, string]} */
  const [software, serial] = key?.split?.('@') || []

  if (!serial) {
    throw new ReferenceError('Invalid PIN content')
  }

  const magicMatch = decryptedPin.match(MAGIC_REGEX)

  return {
    key,
    magic: magicMatch[1],
    serial,
    software,
    created: content.INFO.Time,
    request: content,
  }
}
